import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import { MappingRulesStore, RulesState } from './mapping-rules.store';
import { MappingRulesService } from './mapping-rules.service';
import {
    checkFilter,
    flattenNestedObject,
    InferFilter
} from '../../../../shared/state/query-filter.functions';
import { get } from 'dot-prop';
import { MappingRule } from './mapping-rule.model';
import { BooksQuery } from '../../books/state/books.query';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MappingRulesQuery extends QueryEntity<RulesState> {
    constructor(
        protected store: MappingRulesStore,
        private _rulesService: MappingRulesService,
        private _booksQuery: BooksQuery
    ) {
        super(store);
        this._booksQuery.activeBook$
            .pipe(
                switchMap((book) => {
                    return this._rulesService.getAll(book.id);
                })
            )
            .subscribe();
    }

    all$ = this.selectAll();

    selectByFilter$(
        filters?: InferFilter<MappingRule>,
        sortBy: keyof MappingRule | any = 'updatedAt',
        sortByOrder: Order = Order.DESC
    ) {
        // ...flatten nested object and filter out null values
        const FILTERS = Object.entries<any>(flattenNestedObject(filters)).filter(
            (filter) => filter[1] !== null
        );
        return this.selectAll({
            sortBy,
            sortByOrder,
            filterBy: (rule) => {
                if (FILTERS.length > 0) {
                    return !FILTERS.find(([key, criteria]) => {
                        const value = get<string | number>(rule, key);
                        return !checkFilter(value, criteria);
                    });
                } else {
                    return true;
                }
            }
        });
    }
}
